import { ButtonLink, Flex, Heading, Text } from '@applyboard/crystal-ui'
import { ChevronLeftOutlineIcon } from '@applyboard/ui-icons'
import { format } from 'date-fns'
import { StudentApplication } from '../../../components/Application/types'
import { NavBars } from '../../../components/NavBars'
import { convertTimelessDateStrToLocalDate } from '../../../utils/convertTimelessDateStrToLocalDate'
import { ApplicationSteps } from '../../../utils/enums'
import { CreateApplicationErrorBoundary } from '../CreateApplicationErrorBoundary'
import { CurrentProgramSummaryCard } from '../CurrentProgramSummaryCard'
import { ProgramFilters } from '../ProgramFilters'
import { ProgramList } from '../ProgramList'

type SelectProgramProps = Readonly<{
  application: StudentApplication | null
  isCreatingApplication: boolean
  isUpdatingApplication: boolean
  setCurrentStep: (step: ApplicationSteps) => void
  handleCreateApplication: (programIntakeId: string) => void
  handleUpdateApplication: (
    primaryIntakeId: string | null,
    alternateIntakeId: string[] | null,
  ) => void
  currentApplicationId: string
}>

export function SelectProgram(props: SelectProgramProps) {
  return (
    <NavBars maxWidth={680}>
      <CreateApplicationErrorBoundary>
        <Text>
          <ButtonLink
            href={
              props.application?.attributes?.alternateProgramSelected
                ? `/applications/${props.currentApplicationId}`
                : '/'
            }
            leadIcon={ChevronLeftOutlineIcon}
            variant="transparent"
          >
            {props.application?.attributes?.alternateProgramSelected
              ? 'Back to Application details'
              : 'Back to My Applications'}
          </ButtonLink>
        </Text>
        <Flex gap={6} direction="column">
          <Heading level={1} variant="headlineM">
            {props.application ? 'Edit Program Selection' : 'Program Selection'}
          </Heading>
          {props.application ? (
            <CurrentProgramSummaryCard
              applicationSummary={{
                programName: props.application.attributes?.programSelected?.program?.name ?? '',
                campusName: props.application?.attributes?.programSelected?.campus?.name ?? '',
                intakeTermDate: props.application?.attributes?.programSelected?.programIntakeTerm
                  ?.startDate
                  ? format(
                      convertTimelessDateStrToLocalDate(
                        props.application?.attributes?.programSelected?.programIntakeTerm
                          ?.startDate,
                      ),
                      'MMM yyyy',
                    )
                  : '',
              }}
            />
          ) : null}
          <ProgramFilters />
          <ProgramList
            loading={props.isCreatingApplication || props.isUpdatingApplication}
            onSubmit={intakeId => {
              if (!props.application) {
                props.handleCreateApplication(intakeId)
              } else {
                props.handleUpdateApplication(intakeId, null)
              }
            }}
            currentApplication={props.application?.attributes}
          />
        </Flex>
      </CreateApplicationErrorBoundary>
    </NavBars>
  )
}
